<app-loading *ngIf="cargando"></app-loading>
<div *ngIf="!cargando">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" *ngIf="!esDetalle">
    <div class="grid form-group">
      <!-- ESTADO -->
      <div class="col-12">
        <div class="div-form col-12 md:col-4 lg:col-4">
          <label>* {{ "PRODUCTORESTRICCIONES.LBL_TIPOACTIVIDAD" | translate }}</label>
          <p-dropdown disableTab
            id="idTipoActividad"
            name="nomTipoActividad"
            [options]="lisTipoActividadLaboral"
            placeholder="{{ 'LBL_SELECCIONE' | translate }}"
            formControlName="idTipoActividad"
            filter="true"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            optionValue="value"
            optionLabel="label"
          ></p-dropdown>
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.idTipoActividad.invalid"
          >
            {{ "PRODUCTORESTRICCIONES.LBL_TIPOACTIVIDAD" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
        <!-- BOTON AGREGAR -->
        <div *ngIf="!guardando">
          <div class="form-group margin-button">
            <button
              icon="fa fa-plus"
              label="{{ 'BTN_AGREGAR' | translate }}"
              type="button"
              (click)="onSubmit()"
              pButton
            ></button>
          </div>

          <div class="grid" *ngIf="guardando">
            <div class="col-12 md:col-12 lg:col-12 text-center">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
              <span>{{ "LBL_PROCESANDO" | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <!-- LISTADO PERFIL DE RIESGO -->
  <div class="grid">
    <div class="col-12 content-table">
      <div class="col-12 md:col-4 lg:col-4">
        <p-table
          [columns]="columnas"
          #dt
          [value]="listaProductosRestriccionesActividades"
          selectionMode="single"
          dataKey="idProductosRestriccionesActividades"
          [paginator]="true"
          [rows]="10"

          paginatorPosition="bottom"
          [loading]="guardando"
        >
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th
                *ngFor="let col of columns"
                [pSortableColumn]="col.field"
                [pSortableColumnDisabled]="!col.sort"
                class="text-center"
              >
                {{ col.header }}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{ row.actividadLaboral }}</td>
              <td class="text-center">
                <button
                  type="button"
                  class="p-button p-button-success btn"
                  icon="fa fa-trash"
                  data-toggle="tooltip"
                  title="{{ 'BTN_ELIMINAR' | translate }}"
                  pButton
                  (click)="inhabilitarRegistro(row)"
                ></button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ "MSG_NOHAYREGISTROS" | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
